import TitleCustom from "components/CustomTitle";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Footer from "layouts/Footer";
import { getSalesSuperIntendenciaCompaniesSync } from "rest/sync/requestsSync";
import getTableData from "./formatTableData";

import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Tooltip from "@mui/material/Tooltip";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useState } from "react";
import { getSalesSuperIntendenciaCompaniesLinealCharts } from "./charts";
import DropzoneDialogExample from "./dropZone";
import { getExcelData } from "./getExcelData";
//import Plantilla from "./plantillaSuperIntendencia.xls"

function SuperIntendenciaCompanies() {
  const superIndenciaSalesData = getSalesSuperIntendenciaCompaniesSync();
  console.log(superIndenciaSalesData);
  const [showChart, setShowChart] = useState(false);
  const [showLoadFile, setShowLoadFile] = useState(false);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TitleCustom
        title={"Datos públicos referenciales de la Superintendencia de Compañias"}
        excelData={getExcelData(superIndenciaSalesData)}
        excelName={"Datos_Superintendencia_De_Companias.xlsx"}
        showChart={showChart}
        setShowChart={setShowChart}
      ></TitleCustom>
      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Tooltip
          title={`Subir plantilla con los datos de la superintendencia previamente adicionados`}
        >
          <MDButton variant="text" color="dark" onClick={() => setShowLoadFile(true)}>
            <FileUploadIcon></FileUploadIcon>
            Cargar Datos
          </MDButton>
        </Tooltip>
        <Tooltip>
          <a href="/documents/plantillaSuperintendencia.xls" target="_blank">
            <MDButton variant="text" color="success">
              <DownloadIcon></DownloadIcon>
              Plantilla Datos
            </MDButton>
          </a>
        </Tooltip>
        {showLoadFile ? (
          <DropzoneDialogExample
            open={showLoadFile}
            setOpen={setShowLoadFile}
          ></DropzoneDialogExample>
        ) : (
          <div></div>
        )}
      </MDBox>

      <br></br>
      {showChart ? (
        getSalesSuperIntendenciaCompaniesLinealCharts(superIndenciaSalesData)
      ) : (
        <DataTable table={getTableData(superIndenciaSalesData)} canSearch={true} />
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default SuperIntendenciaCompanies;
